module.exports = __webpack_public_path__ + "img/combinado.5e9aa53c.png";